const initialState = {
    test: 'teaaast'
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default: {
      return state;
    }
  }
};

export default reducer;
